import './SideNavigation.css';
import { useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logoImage from '../../assets/Logo.png';

function SideNavigation({ onLogout, user, drawerOpen, onCloseDrawer, isMobile }) {
  const location = useLocation();

  const handleNavClick = () => {
    if (isMobile) onCloseDrawer?.();
  };

  useEffect(() => {
    if (!isMobile) return;
    onCloseDrawer?.();
  }, [location.pathname, isMobile, onCloseDrawer]);

  useEffect(() => {
    if (!isMobile || !drawerOpen) return;
    const prev = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = prev;
    };
  }, [isMobile, drawerOpen]);

  useEffect(() => {
    if (!isMobile || !drawerOpen) return;
    const onKey = (e) => {
      if (e.key === 'Escape') onCloseDrawer?.();
    };
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [isMobile, drawerOpen, onCloseDrawer]);

  return (
    <>
      {isMobile && drawerOpen && (
        <div
          className="drawer-scrim"
          onClick={onCloseDrawer}
          aria-hidden="true"
        />
      )}
      <aside
        className={`side-navigation ${isMobile && drawerOpen ? 'open' : ''}`}
        aria-hidden={isMobile && !drawerOpen}
      >
        <div className="logo-container">
          <img src={logoImage} alt="HANDS-ON INNOVATIONS" className="logo-image" />
        </div>

        <nav className="nav-menu">
          <Link
            to="/dashboard"
            className={`nav-item ${location.pathname === '/dashboard' ? 'active' : ''}`}
            onClick={handleNavClick}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="7" height="7"></rect>
              <rect x="14" y="3" width="7" height="7"></rect>
              <rect x="14" y="14" width="7" height="7"></rect>
              <rect x="3" y="14" width="7" height="7"></rect>
            </svg>
            <span>Dashboard</span>
          </Link>

          <Link
            to="/playlists"
            className={`nav-item ${location.pathname === '/playlists' ? 'active' : ''}`}
            onClick={handleNavClick}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="3" y="3" width="18" height="18" rx="2" ry="2"></rect>
              <line x1="9" y1="3" x2="9" y2="21"></line>
              <line x1="15" y1="3" x2="15" y2="21"></line>
            </svg>
            <span>Playlists</span>
          </Link>

          <Link
            to="/devices"
            className={`nav-item ${location.pathname === '/devices' ? 'active' : ''}`}
            onClick={handleNavClick}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <rect x="2" y="3" width="20" height="14" rx="2"></rect>
              <line x1="8" y1="21" x2="16" y2="21"></line>
              <line x1="12" y1="17" x2="12" y2="21"></line>
            </svg>
            <span>Devices</span>
          </Link>

          <Link
            to="/device-groups"
            className={`nav-item ${location.pathname === '/device-groups' ? 'active' : ''}`}
            onClick={handleNavClick}
          >
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
              <circle cx="9" cy="7" r="4"></circle>
              <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
              <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
            </svg>
            <span>Groups</span>
          </Link>

          {(user?.role === 'company_admin' || user?.role === 'platform_super_admin') && (
            <Link
              to="/users"
              className={`nav-item ${location.pathname === '/users' ? 'active' : ''}`}
              onClick={handleNavClick}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"></path>
                <circle cx="9" cy="7" r="4"></circle>
                <path d="M23 21v-2a4 4 0 0 0-3-3.87"></path>
                <path d="M16 3.13a4 4 0 0 1 0 7.75"></path>
              </svg>
              <span>Users</span>
            </Link>
          )}

          {user?.role === 'platform_super_admin' && (
            <Link
              to="/companies"
              className={`nav-item ${location.pathname === '/companies' ? 'active' : ''}`}
              onClick={handleNavClick}
            >
              <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
                <path d="M3 21h18"></path>
                <path d="M5 21V7l8-4 8 4v14"></path>
                <path d="M9 21v-8h6v8"></path>
              </svg>
              <span>Companies</span>
            </Link>
          )}
        </nav>

        <div className="nav-footer">
          <div className="user-info">
            <div className="user-avatar">
              {user?.username?.charAt(0).toUpperCase()}
            </div>
            <div className="user-details">
              <div className="user-name">{user?.username}</div>
              <div className="user-role">{user?.role || 'User'}</div>
            </div>
          </div>
          <button type="button" onClick={onLogout} className="logout-btn" aria-label="Log out">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4"></path>
              <polyline points="16 17 21 12 16 7"></polyline>
              <line x1="21" y1="12" x2="9" y2="12"></line>
            </svg>
          </button>
        </div>
      </aside>
    </>
  );
}

export default SideNavigation;
